import PortfolioNavigation from "@common/Components/PortfolioNavigation.vue";
import Navigation from '@common/Navigation.vue';
import { CurrencyDenomination } from '@common/types';
import PnlViewer from "@Quest/Pnls/Components/PnlViewer.vue";
import { PnlTemplateReadModel } from '@Quest/Pnls/Domain/readmodels';
import PortfoliosQueries from '@Quest/Portfolios/Domain/queries-vue-component';
import { AlternativesViewDefReadModel, PnlPageReadModel } from '@Quest/Portfolios/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';

@Component({
    components: {
        PortfolioNavigation, PnlViewer, Navigation
    }
})
export default class PnlPage extends mixins(PortfoliosQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get viewDefId(): string | null { return this.$route.params.viewDefId ?? null; }

    rm: PnlPageReadModel | null = null;

    get isWorkspaceMember(): boolean { return this.rm?.IsWorkspaceMember ?? false; }
    get denomination(): CurrencyDenomination | null { return this.rm?.Denomination; }
    get pnlTemplates(): PnlTemplateReadModel[] { return this.rm?.Templates ?? []; }
    get views(): AlternativesViewDefReadModel[] { return this.rm?.Lists ?? []; }
    get pnlTemplateName(): string { return this.rm?.PnlTemplateName ?? ''; }
    get viewDefName(): string { return this.rm?.ViewDefName ?? ''; }
    get applyBenefitsConfidenceFactor(): boolean { return this.rm?.IsBenefitsConfidenceFactorApplied ?? false; }
    get cagrVisible(): boolean { return this.$route.query.cagr === "true"; }
    get activeSharesCount(): number | null { return this.rm.ActiveSharesCount; }
    get shareId(): string { return this.rm.ShareId; }


    setViewDefId(viewDefId: string | null)
    {
        this.$router.push({
            params: { ...this.$route.params, viewDefId: viewDefId },
            query: this.$route.query 
        });
    }

    setDenomination(denomination: string)
    {
        this.$router.replace({
            params: this.$route.params,
            query: { ...this.$route.query, denomination }
        });
    }

    setPnlTemplate(pnlTemplateId: string | null)
    {
        this.$router.replace({
            params: this.$route.params,
            query: { ...this.$route.query, pnlTemplateId }
        });
    }

    toggleBenefitsConfidenceFactor()
    {
        this.$router.replace({
            params: this.$route.params,
            query: { ...this.$route.query, risk: String(!this.applyBenefitsConfidenceFactor) }
        });
    }

    toggleCagr()
    {
        this.$router.replace({
            params: this.$route.params,
            query: { ...this.$route.query, cagr: String(!this.cagrVisible) }
        });
    }


    mounted()
    {
        document.title = "P&L | TransparentChoice";

        const denomination = this.$route.query.denomination as CurrencyDenomination || CurrencyDenomination.Million;
        const pnlTemplateId: string | null = this.$route.query.pnlTemplateId as string;
        const applyBenefitsConfidenceFactor = this.$route.query.risk === "true";

        this.runPnlPageQueryV1(this.workspaceId, this.tchProjectId, this.viewDefId, pnlTemplateId, applyBenefitsConfidenceFactor, denomination);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "PnlPageReadModel")
        {
            this.rm = model as PnlPageReadModel;
        }
    }
}